export default __webpack_public_path__ + "8be2a9d3f19d0f5348747e90150c72cf.svg";